export default __webpack_public_path__ + "static/media/wedding-couple.ca4677ee.png";